module.exports = __webpack_public_path__ + "assets/img/services4.391c2899.svg";